/* eslint-disable object-curly-newline */
import update from 'immutability-helper';
import naturalCompare from 'string-natural-compare';
import { indexById } from '../indexById/indexById';
import { get as getId } from '../localId/localId';

export const ADD_LOCAL_EQUIPMENT = 'ADD_LOCAL_EQUIPMENT';
export const REMOVE_LOCAL_EQUIPMENT = 'REMOVE_LOCAL_EQUIPMENT';
export const API_LOAD_EQUIPMENTS = 'API_LOAD_EQUIPMENTS';
export const API_REMOVE_EQUIPMENT = 'API_REMOVE_EQUIPMENT';
export const API_CREATE_EQUIPMENT = 'API_CREATE_EQUIPMENT';
export const API_UPDATE_EQUIPMENT = 'API_UPDATE_EQUIPMENT';

const API_LOAD_EQUIPMENTS_FAILED = 'API_LOAD_EQUIPMENTS_FAILED';
const API_LOAD_EQUIPMENTS_LOADING = 'API_LOAD_EQUIPMENTS_LOADING';
const API_LOAD_EQUIPMENTS_LOADED = 'API_LOAD_EQUIPMENTS_LOADED';
const API_REMOVE_EQUIPMENT_FAILED = 'API_REMOVE_EQUIPMENT_FAILED';
const API_REMOVE_EQUIPMENT_LOADING = 'API_REMOVE_EQUIPMENT_LOADING';
const API_REMOVE_EQUIPMENT_SUCCESS = 'API_REMOVE_EQUIPMENT_SUCCESS';
const API_CREATE_EQUIPMENT_FAILED = 'API_CREATE_EQUIPMENT_FAILED';
const API_CREATE_EQUIPMENT_LOADING = 'API_CREATE_EQUIPMENT_LOADING';
const API_CREATE_EQUIPMENT_SUCCESS = 'API_CREATE_EQUIPMENT_SUCCESS';
const API_UPDATE_EQUIPMENT_FAILED = 'API_UPDATE_EQUIPMENT_FAILED';
const API_UPDATE_EQUIPMENT_LOADING = 'API_UPDATE_EQUIPMENT_LOADING';
const API_UPDATE_EQUIPMENT_SUCCESS = 'API_UPDATE_EQUIPMENT_SUCCESS';

const defaultState = { equipments: [], loading: false };
const emptyEquipment = () => ({ id: getId(), name: '', isRemoving: false });
const mapDefaults = equipment => ({ ...emptyEquipment(), ...equipment });

export const reducer = (state = defaultState, { type, response, id, replaceId, resource }) => {
  switch (type) {
    case API_LOAD_EQUIPMENTS_LOADED:
      return update(state, {
        loading: { $set: false },
        equipments: { $set: response.map(mapDefaults) },
      });
    case API_LOAD_EQUIPMENTS_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_EQUIPMENTS_FAILED:
      return update(state, { loading: { $set: false } });
    case ADD_LOCAL_EQUIPMENT:
      return update(state, { equipments: { $push: [emptyEquipment()] } });
    case API_REMOVE_EQUIPMENT_SUCCESS:
    case REMOVE_LOCAL_EQUIPMENT:
      return update(state, { equipments: { $splice: [[indexById(id, state.equipments), 1]] } });
    case API_REMOVE_EQUIPMENT_FAILED:
      return update(state, { equipments: { [indexById(id, state.equipments)]: { removing: { $set: false } } } });
    case API_REMOVE_EQUIPMENT_LOADING:
      return update(state, { equipments: { [indexById(id, state.equipments)]: { removing: { $set: true } } } });
    case API_CREATE_EQUIPMENT_FAILED:
      return update(state, { equipments: { [indexById(resource.id, state.equipments)]: { saving: { $set: false } } } });
    case API_CREATE_EQUIPMENT_LOADING:
      return update(state, { equipments: { [indexById(resource.id, state.equipments)]: { saving: { $set: true } } } });
    case API_CREATE_EQUIPMENT_SUCCESS:
      return update(state, { equipments: { $splice: [[indexById(replaceId, state.equipments), 1, response]] } });
    default:
      return state;
  }
};

export const equipments = (state, classId) => {
  let equipment = state.equipments.equipments;
  if(classId !== undefined && classId !== "") {
    equipment = equipment.filter((a) =>
      (a.equipment_category_id === Number.parseInt(classId, 10)) ||
      (!a.name && !a.equipment_category_id)
    )
  }
  return equipment.sort((a, b) => naturalCompare.caseInsensitive(a.name, b.name));
};


export const groupedActiveEquipment = state =>
  equipments(state).filter(e => !e.hide).reduce((newObject, object) => {
    const equipmentCategory = object.equipment_category || { name: 'Other' };

    const index = newObject.findIndex(o => o.label === equipmentCategory.name);
    const optionGroup = newObject[index]
      || { label: equipmentCategory.name, options: [] };

    optionGroup.options.push({ label: object.name, value: object.id });

    if (index > -1) update(newObject, { [index]: { $set: optionGroup } });
    else newObject.push(optionGroup);

    return newObject;
  }, []).sort((a, b) => naturalCompare.caseInsensitive(a.label, b.label));

export const loading = state => state.equipments.loading;

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/equipment/equipment.reducer.js